import { render, staticRenderFns } from "./DrawableCanvas.vue?vue&type=template&id=038678c6&"
import script from "./DrawableCanvas.vue?vue&type=script&lang=js&"
export * from "./DrawableCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports